import AnimalView from "./AnimalView";

export default AnimalView;
